<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: FooterBar
 * @Description: 底部组件
 * @FilePath: \web_manage_globalf:\work\web\app-tikfriend_web\src\components\FooterBar.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-28 14:52:11
 * @LastEditors: syl
 * @LastEditTime: 2022-05-23 16:29:27
 * @example: 调用示例
-->
<template>
  <footer class="footer-x">
    <div class="describe-image" v-if="false">
      <img :src="require('../assets/home_' + curEquip + '_' + describeData + '.png')" />
    </div>
    <div class="footer">
      <p class="link">
        <a href="https://goudrive.tikfriend.com:89/treaty.html?id=1457905709680300032"
          >《互勾隐私政策》</a
        ><a href="https://goudrive.tikfriend.com:89/treaty.html?id=1457905510480220160"
          >《用户服务协议》</a
        >
      </p>
      <p>
        <span class="copyright"
          >© 2016 - 2022 泉州砾鹰石科技有限公司 版权所有
        </span>
        <span class="icp"
          >|
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >闽ICP备17029570号-2
          </a>
          <img src="../assets/icp_public.png" alt="闽公网" />
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35050202000187"
            target="_blank"
            >闽公网安备 35050202000187号</a
          ></span>
          <span class="icp">|
          <span class="copyright">增值电信业务经营许可证：  <a :href="require('../assets/images/licence_1.png')" target="_blank">闽B2-20200365，
          </a ><a :href="require('../assets/images/licence_2.png')" target="_blank">B1.B2-20214072</a>
        </span>
        </span>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterBar",
  props: {
    describeData: {
      typpe: String,
      default: 'chat'
    }
  },
  data() {
    return {
      curImg: '',
      curEquip: localStorage.getItem('curEquip')
    }
  }
};
</script>
